'use client';

import { processClassName } from '@/app/_lens-components/style/responsive';
import Dialog from '@/components/Dialog';
import { IS_FR } from '@/utils/constants';
import { useMediaQuery } from '@mui/material';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
export default function PrGuidePop({
  showPrGuide,
  handleClosePrGuide,
  scanItem,
}: {
  showPrGuide: boolean;
  handleClosePrGuide: () => void;
  scanItem: () => ReactNode;
}) {
  const isMobile = useMediaQuery('(max-width:700px)');
  const t = useTranslations('lens-process');
  return (
    <Dialog
      open={showPrGuide}
      onClose={handleClosePrGuide}
      footer={null}
      showCloseIcon={false}
      hideHeader
      sx={{
        '& .MuiDialog-container': {
          alignItems: 'flex-start',
        },
        '& .MuiDialog-paper': {
          backgroundColor: 'transparent',
        },
        '& .MuiPaper-root': {
          maxWidth: 'none',
          width: '100vw',
          margin: '0',
          boxShadow: 'none',
        },
        '& .MuiDialogContent-root': {
          padding: '0',
          overflow: 'hidden',
        },
      }}
    >
      <div className="w-[100vw] flex">
        <div className={processClassName.leftPart} />
        <div className={processClassName.rightPart}>
          <div className={processClassName.rightPartContent}>
            <div
              className={`pt-[68px] mt-[40px] xl:mt-[65px] max-xl:px-[14px] ${processClassName.rightPartBox} flex flex-col items-end justify-end`}
            >
              <div className="flex w-full">
                <div className="flex-1 basis-[110px]" />
                {scanItem()}
              </div>
              <section
                className={`min-h-[55px] relative right-[-12px] bg-[url('/zeelool-next/lens-process/tip_body.png')] bg-size-[100%_100%] box-content p-[20px_22px_25px_24px] text-white text-[12px] leading-[18px]
                ${IS_FR && !isMobile ? 'w-[352px]' : 'min-w-[234px]'}`}
              >
                {isMobile ? (
                  <div
                    style={IS_FR ? { lineHeight: 1.2 } : {}}
                    dangerouslySetInnerHTML={{
                      __html: t('prescriptionToolDescription'),
                    }}
                  />
                ) : (
                  <div>
                    {t('tryOurPrescriptionRecognitionTool')}
                    <br />
                    {t('uploadAPhotOfYourPrescription')}
                    <br />
                    {t('weWillFillInTheDetailsForYou')}
                  </div>
                )}
              </section>
              <span
                className="block px-[6px] h-[24px] rounded-[12px] border border-white text-white text-center leading-[24px] text-[12px] cursor-pointer notranslate"
                onClick={(e) => {
                  e.stopPropagation();
                  handleClosePrGuide();
                }}
              >
                {t('skip')}
              </span>
            </div>
            <div className={processClassName.rightPartSide} />
          </div>
        </div>
      </div>
    </Dialog>
  );
}
